import React, { useState, useEffect } from 'react';
import Layout from './Layout';
import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useParams, Redirect } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { url, getToken } from './_helpers'
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Canvas } from '@react-pdf/renderer';
import { Table, TableCell, TableHeader, TableBody, DataTableCell } from '@david.kucsai/react-pdf-table'
import { PDFViewer } from '@react-pdf/renderer';
import {formatDate} from './_helpers'

export const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        marginBottom: '10px',
        height: '800px'
    },
    fixedHeight: {
        height: 240,
    },
}));

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: 'white',
        padding: '15pt',
        width: '100%'
    },
    text: {
        width: "100%",
        backgroundColor: "#f0f0f0",
        color: "#212121"
    }
});

const loja = {
    SAUDE: {
        endereco: 'Rua Francisco Tapajós 149 – Saúde – São Paulo – SP',
        telefone: '(11) 5068-2783',
        email: 'saude@gbforros.com.br'
    },
    VILA_MARIA: {
        endereco: 'Rua Dias da Silva, nº 1131 – Vila Maria – São Paulo – SP',
        telefone: '(11) 2954-3736',
        email: 'vilamaria@gbforros.com.br'
    }
}

const defaultStyle = ReactPDF.Style = {
    display: 'flex',
    flexBasis: '100%',
    flexWrap: 'wrap',
    paddingTop: '5px',
    paddingBottom: '5px',
    wordWrap: "break-word",
    whiteSpace: "pre-wrap"
};

export default function PdfRelatorio(props) {
    let { inicio, fim } = useParams();
    const inicioData = new Date(inicio);
    const fimData = new Date(fim);
    const [error, setError] = useState({});
    const [redirecionar, setRedirecionar] = useState(false);
    const [values, setValues] = useState({
        totalBalcaoVM: 0,
        totalBalcaoS: 0,
        totalInstaladosVM: 0,
        totalInstaladosS: 0,
    });
    const { enqueueSnackbar } = useSnackbar();

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        if (inicio && fim)
            fetch(`${url}/servicos/relatorio/${inicio}/${fim}`, {
                headers: {
                    'Authorization': `Bearer ${encodeURI(getToken().token)}`,
                }
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        setValues(result)
                    },
                    (error) => {
                        console.log(error)
                    }
                )
    }, []);


    const classes = useStyles();
    return (
        <Layout>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <PDFViewer style={{
                            height: '800px'
                        }}>
                            <Document title={`visita-${values.codigo}`}>
                                <Page size="A4" style={styles.page}>
                                    <View style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                                        <View style={{
                                            flexDirection: "row",
                                            justifyContent: "stretch",
                                            width: "100%",
                                            display: "flex"

                                        }}>
                                            <View style={{ ...defaultStyle, width: '30%', border: "1pt solid black", paddingTop: '30pt', textAlign: 'center'}}>
                                                <Image source={require('./gb-logo-site.png')} style={{width: '40%', marginLeft: 40}}/>
                                                <Text>Forros de PVC</Text>
                                            </View>
                                            <View style={{ ...defaultStyle, width: '70%', border: "1pt solid black", textAlign: 'center', }}>
                                                <View style={{ ...defaultStyle, width: '100%', borderBottom: "1pt solid black", fontSize: '16pt' }}>
                                                    <Text>Clanil Comércio de Plasticos LTDA-ME</Text>
                                                </View>
                                                <View style={{ ...defaultStyle, width: '100%', fontSize: '10pt' }}>
                                                    <Text style={{ marginBottom: '5pt' }}>CNPJ: 09.013.810/0001-57 - IE: 149.780.989.110</Text>
                                                    <Text style={{ marginBottom: '5pt' }}>{loja['SAUDE'].endereco}</Text>
                                                    <Text style={{ marginBottom: '5pt' }}>{`Telefone: ${loja['SAUDE'].telefone}`}</Text>
                                                    <Text style={{ marginBottom: '5pt' }}>{`Website: https://gbforros.com Email: ${loja['SAUDE'].email}`}</Text>
                                                </View>
                                                <View style={{ ...defaultStyle, width: '100%', fontSize: '14pt', borderTop: "1pt solid black" }}>
                                                    <Text>{`Relatorio - Inicio: ${formatDate(inicioData.setDate(inicioData.getDate() + 1))} | Fim: ${formatDate(fimData.setDate(fimData.getDate() + 1))}`}</Text>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={{
                                            flexDirection: "row",
                                            justifyContent: "stretch",
                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>

                                            <View style={{ ...defaultStyle, fontSize: '10pt', paddingLeft: '15px' }}>
                                                <Text style={{ marginBottom: '5pt', fontSize: '12pt' }}>Dados da loja da Saúde</Text>
                                                <Text style={{ marginBottom: '5pt' }}>Vendas realizadas no balcão: {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((values.totalBalcaoS))}</Text>
                                                <Text style={{ marginBottom: '5pt' }}>Vendas por instalados: {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((values.totalInstaladosS))}</Text>
                                            </View>
                                        </View>
                                        <View style={{
                                            flexDirection: "row",
                                            justifyContent: "stretch",
                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>
                                            <View style={{ ...defaultStyle, fontSize: '10pt', paddingLeft: '15px' }}>
                                                <Text style={{ marginBottom: '5pt', fontSize: '12pt' }}>Dados da loja da Vila Maria</Text>
                                                <Text style={{ marginBottom: '5pt' }}>Vendas realizadas no balcão: {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((values.totalBalcaoVM))}</Text>
                                                <Text style={{ marginBottom: '5pt' }}>Vendas por instalados: {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((values.totalInstaladosVM))}</Text>
                                            </View>
                                        </View>
                                    </View>



                                </Page>
                            </Document>
                        </PDFViewer>
                    </Paper>
                </Grid>
            </Grid>
        </Layout>
    )
}